// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import './styles.scss'
import { PureCopyrightNotice as CopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import ShareButtons from '@ta-interaktiv/react-share-buttons'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'

type Props = {
  articleId: string,
  publicationDate: number
}

export function Footer({ articleId, publicationDate }: Props) {
  return (
    <footer className='ui vertical padded grey segment ta footer'>
      <div className='ui container'>
        <div className='ui grid'>
          <div className='two column stackable row'>
            <div className='column'>
              <table className='ui small very basic definition infographic unstackable table top aligned'>
                <tbody>
                  <tr className={'top aligned'}>
                    <td>Text</td>
                    <td>
                      <div className='ui list'>
                        <div className={'item'}>Mathias Plüss, Das Magazin</div>
                      </div>
                    </td>
                  </tr>
                  <tr className={'top aligned'}>
                    <td>Quellen (herzlichen Dank!)</td>
                    <td>
                      <div className='ui list'>
                        <div className={'item'}>Christian Bach/Empa, Niels Jungbluth/ESU-services, Daniela Pauli/SCNAT, Jürg Artho/UZH, ARE, BAFU, BFE, BFS, BLV, Umweltbundesamt, EPFL, ETHZ, FiBL, Uni Basel, Uni Bonn, ZHAW, Eco-Drive, EnergieSchweiz, Eurostat, FAOSTAT, Foodwaste.ch, IEA, IUCN, Minergie Schweiz, Movinga, myclimate, ProClim, SGE, Swiss, WWF, «Annabelle, «Beobachter», digiconomist, «Nature», NZZ, «Scientific American», «Spiegel», «Spektrum», SRF, «Tages-Anzeiger», «Tierwelt», «Welt», «Zofinger Tagblatt».</div>
                      </div>
                    </td>
                  </tr>
                  <tr className={'top aligned'}>
                    <td>Digitale Umsetzung</td>
                    <td>Mathias Lutz</td>
                  </tr>
                  <tr>
                    <td>Veröffentlicht</td>
                    <td>
                      <TimestampFormatter timestamp={publicationDate} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='column'>
              <FeedbackMessage />

              <div className='ui vertical very fitted center aligned segment'>
                <ShareButtons className='basic' articleId={articleId} />
              </div>
            </div>
          </div>

          <div className='two column stackable row'>
            <div className='column'>
              <div className='ui two column grid bottom aligned'>
                <div className='column'>
                  <CopyrightNotice
                    name={'Das Magazin'}
                    secondLevelDomainName={'dasmagazin'}
                    year={'2018'}
                    inverted={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
